import { IMechanicListState } from "./mechanicList.types";

export const initialMechanicListState: IMechanicListState = {
  list: [],
  totalRecords: 0,
  loading: false,
  filters: {
    dateRange: "Last 30 Days",
    shift: "All Shifts",
    type: "All Types",
    rsaSow: "Search RSA/SOW",
    searchBy: "Search By",
    searchQuery: "",
  },
};
